const CandidateDocumentFileType = {
  Url: "URL",
  File: "FILE"
};

export { CandidateDocumentFileType };
//# sourceMappingURL=candidate-document-file-type.mjs.map
